module.exports = __webpack_public_path__ + "static/media/icon_change_drawer.dac743d3.svg";